import React from 'react';
import { Box, Paper, Typography, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

function WorkshopContactCard({ phone, address }) {
  const { t } = useTranslation();

  if (!phone && !address) return null;

  return (
    <Paper
      elevation={0}
      data-testid="workshop-contact-card"
      sx={{
        backgroundColor: theme.colors.surface,
        borderRadius: theme.radius.xl,
        padding: '20px',
        boxShadow: theme.shadows.md,
        marginBottom: '20px',
      }}
    >
      <Typography
        component="h3"
        sx={{ fontSize: '16px', fontWeight: '700', margin: '0 0 16px 0' }}
      >
        {t('public_maintenance.contact')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {phone && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Box
              sx={{
                width: '40px',
                height: '40px',
                backgroundColor: `${theme.colors.accentLight}20`,
                borderRadius: theme.radius.md,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.colors.accent,
              }}
            >
              <PhoneIcon sx={{ fontSize: 20 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: '12px', color: theme.colors.textMuted }}>
                {t('public_maintenance.phone')}
              </Typography>
              <Link
                href={`tel:${phone}`}
                sx={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: theme.colors.accent,
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                {phone}
              </Link>
            </Box>
          </Box>
        )}
        {address && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Box
              sx={{
                width: '40px',
                height: '40px',
                backgroundColor: `${theme.colors.accentLight}20`,
                borderRadius: theme.radius.md,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.colors.accent,
              }}
            >
              <LocationOnIcon sx={{ fontSize: 20 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: '12px', color: theme.colors.textMuted }}>
                {t('public_maintenance.address')}
              </Typography>
              <Typography sx={{ fontSize: '14px', color: theme.colors.text }}>
                {address}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default WorkshopContactCard;
